// extracted by mini-css-extract-plugin
export default {"component":"LandDisplayInfo_component__kups9","plotHeader":"LandDisplayInfo_plotHeader__K2Q8P","container":"LandDisplayInfo_container__K2dVs"};